<template>
  <div class="card-content client-payeur client-payeur--only">
    <div class="payeur-infos">
      <b-field class="payeur-infos__name">
        <router-link-blank
          classMessage="has-text-weight-bold lien mgr-5px"
          :to="{ name: 'c.baux.bailleur',
                params: { id: bailleur.tiersId }}"
          :message="bailleur.nomCommercial"/>
      </b-field>
      <div v-if="adresse">
        {{ $t('editCommandeAchatBailleur.bailleur.adresse') }} <br>
        <div class="payeur-infos__address">{{ adresse }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  props: {
    bailleur: {
      required: true,
      type: Object,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    adresse() {
      return adressFullStringGetter(this.bailleur.tiers.adressePostale, false, true);
    },
  },
};

</script>
